import React from 'react';

import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const ReactHookFormSelect = ({
    control,
    disabled,
    fullWidth = true,
    id,
    label = '',
    name,
    onChange,
    options,
    sxFormControl = {},
    variant,
}) => (
    <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => {
            const valueIsBetweenTheOptions = options.filter(
                (option) => option.value === field.value,
            );

            return (
                <FormControl
                    error={Boolean(error)}
                    fullWidth={fullWidth}
                    size="small"
                    {...sxFormControl}
                    variant={variant}
                >
                    <InputLabel
                        {...(field?.value &&
                            valueIsBetweenTheOptions.length && {
                                shrink: Boolean(field.value),
                            })}
                    >
                        {label}
                    </InputLabel>
                    <Select
                        disabled={disabled}
                        displayEmpty={label === ''}
                        id={id}
                        label={label}
                        {...field}
                        onChange={(e) => {
                            field.onChange(e);
                            if (onChange) onChange(e);
                        }}
                        value={
                            field.value !== null &&
                            valueIsBetweenTheOptions.length
                                ? field.value
                                : ''
                        }
                    >
                        {options.map(
                            ({ label, value, disabled: optionDisabled }) => (
                                <MenuItem
                                    disabled={optionDisabled}
                                    key={`select-${value}-${label}`}
                                    value={value}
                                >
                                    {label}
                                </MenuItem>
                            ),
                        )}
                    </Select>
                    {Boolean(error) && (
                        <FormHelperText>{error?.message}</FormHelperText>
                    )}
                </FormControl>
            );
        }}
    />
);

ReactHookFormSelect.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    required: PropTypes.bool,
    sxFormControl: PropTypes.object,
    variant: PropTypes.string,
};

export default ReactHookFormSelect;
